export default __webpack_public_path__ + "_/images/bonuses/bonuses-card/cake-4a66fbb05b5a1c81ac0eef10f8249cdd93c129f6135097772fa1e8fb4bc87131.png";